<template>
  <div class="rv-container">
    <v-tabs v-model="activeTab" class="rv-tabs elevation-1" background-color="white" color="#1a6fb5" slider-size="3">
      <v-tab class="rv-tab">
        <v-icon left small>mdi-receipt-text-outline</v-icon>
        Detalle de Ventas
      </v-tab>
      <v-tab v-if="accountData" class="rv-tab">
        <v-icon left small>mdi-link-variant</v-icon>
        Cuentas Asociadas
      </v-tab>
      <v-tab class="rv-tab">
        <v-icon left small>mdi-database-outline</v-icon>
        Data
      </v-tab>
      <v-tab class="rv-tab">
        <v-icon left small>mdi-code-json</v-icon>
        Raw
      </v-tab>

      <!-- ==================== TAB 1: DETALLE DE VENTAS ==================== -->
      <v-tab-item class="pa-5 rv-tab-content">

        <!-- ── Info Card: Folio + Metadata ── -->
        <v-card class="rv-info-card mb-6 elevation-2" rounded="lg">
          <div class="rv-info-header">
            <div class="d-flex align-center justify-space-between flex-wrap">
              <div class="d-flex align-center">

                <div>
                  <div class="rv-folio-label">FOLIO</div>
                  <div class="rv-folio-value">{{ selectedReserva.Folio ? selectedReserva.Folio : '—' }}</div>
                </div>
              </div>
              <v-chip dark class="rv-turno-chip" label>
                <v-icon left x-small>mdi-clock-outline</v-icon>
                Turno:
                <template v-if="!v2">{{ selectedReserva.Turno ? selectedReserva.Turno : '—' }}</template>
                <template v-if="v2">{{ selectedReserva.Turno ? selectedReserva.Turno.id : '—' }}</template>
              </v-chip>
            </div>
          </div>

          <v-card-text class="pa-0">
            <div class="rv-meta-grid">
              <div class="rv-meta-item">
                <div class="rv-meta-icon-wrap" style="background: #e3f2fd;">
                  <v-icon color="#1565c0" small>mdi-account</v-icon>
                </div>
                <div>
                  <div class="rv-meta-label">Cliente</div>
                  <div class="rv-meta-value">{{ selectedReserva.Cliente ? selectedReserva.Cliente.Nombre : '—' }}</div>
                </div>
              </div>
              <div class="rv-meta-item">
                <div class="rv-meta-icon-wrap" style="background: #e8f5e9;">
                  <v-icon color="#2e7d32" small>mdi-calendar</v-icon>
                </div>
                <div>
                  <div class="rv-meta-label">Fecha</div>
                  <div class="rv-meta-value">{{ selectedReserva.FechaVenta ? selectedReserva.FechaVenta : '—' }}</div>
                </div>
              </div>
              <div class="rv-meta-item">
                <div class="rv-meta-icon-wrap" style="background: #fff3e0;">
                  <v-icon color="#e65100" small>mdi-cash-register</v-icon>
                </div>
                <div>
                  <div class="rv-meta-label">Caja</div>
                  <div class="rv-meta-value">{{
                    selectedReserva.Caja
                      ? $pgsHelper.getById(data_cajas, 'id', selectedReserva.Caja).Nomb
                      : '—'
                  }}</div>
                </div>
              </div>
              <div class="rv-meta-item">
                <div class="rv-meta-icon-wrap" style="background: #f3e5f5;">
                  <v-icon color="#7b1fa2" small>mdi-account-tie</v-icon>
                </div>
                <div>
                  <div class="rv-meta-label">Cajero</div>
                  <div class="rv-meta-value">{{
                    selectedReserva.Cajero
                      ? $pgsHelper.getById(cashiers, 'Id', selectedReserva.Cajero).Nomb
                      : '—'
                  }}</div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- ── Tabla de Productos ── -->
        <div class="rv-section mb-6">
          <div class="rv-section-header">

            <span class="rv-section-title">Productos</span>
            <v-spacer></v-spacer>
            <v-chip small outlined color="grey" class="rv-count-chip">
              {{ selectedReserva.ListProducts ? selectedReserva.ListProducts.length : 0 }} items
            </v-chip>
          </div>
          <v-divider class="mb-0"></v-divider>
          <v-simple-table class="rv-table">
            <thead>
              <tr class="rv-table-header">
                <th>Producto</th>
                <th class="text-center">Cantidad</th>
                <th class="text-right">Precio U.</th>
                <th class="text-right">Precio Total</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(producto, index) in selectedReserva.ListProducts
                ? selectedReserva.ListProducts
                : []">
                <tr :key="index" class="rv-table-row">
                  <td data-label="producto">
                    <div class="rv-product-name">
                      {{ producto[1].Nombre }}
                      <span v-if="producto[1].STip == 'Cuenta'" class="rv-product-date">
                        {{ $pgsHelper.getDate(producto[1].ExtraParams.Crat).format("DD/MM/YYYY") }}
                      </span>
                    </div>
                    <div v-if="producto[1].ModificadoresList && producto[1].ModificadoresList.length"
                      class="rv-sub-items mt-1">
                      <v-chip v-for="(modi, idx) in producto[1].ModificadoresList" :key="'m' + idx" x-small outlined
                        color="#1a6fb5" class="mr-1 mb-1">
                        {{ modi.Cnt }} × {{ modi.nam }}
                        <span class="ml-1 font-weight-medium">{{ modi.pco.C }} {{ modi.pco.M }}</span>
                      </v-chip>
                    </div>
                    <div v-if="producto[1].Descuentos && producto[1].Descuentos.length" class="rv-sub-items mt-1">
                      <v-chip v-for="(Desc, idx) in producto[1].Descuentos" :key="'d' + idx" x-small outlined
                        color="orange darken-2" class="mr-1 mb-1">
                        {{ Desc.Cnt }} × {{ Desc.Dsc }}
                        <span class="ml-1 font-weight-medium">{{ Desc.Ttl.C }} {{ Desc.Ttl.M }}</span>
                      </v-chip>
                    </div>
                    <div v-if="producto[1].Catalogo" class="rv-sub-items mt-1">
                      <template v-for="(modi, idx) in producto[1].Catalogo">
                        <v-chip v-if="modi.Tipo !== 'AYB-Insumo' && modi.Tipo !== 'AYB-ICompuesto'" :key="idx + 'cat'"
                          x-small outlined color="teal" class="mr-1 mb-1">
                          {{ modi.Cnt }} × {{ modi.Nombre }}
                          <span class="ml-1 font-weight-medium">{{ modi.Pco ? modi.Pco.C : 0 }} {{ modi.Pco ? modi.Pco.M
                            : '' }}</span>
                        </v-chip>
                      </template>
                    </div>
                  </td>
                  <td data-label="Cantidad" class="text-center rv-cell-mono">{{ producto[1].Cnt }}</td>
                  <td data-label="Precio" class="text-right rv-cell-mono">
                    {{ producto[1].Pco.C }} {{ producto[1].Pco.M }}
                  </td>
                  <td data-label="Precio" class="text-right rv-cell-mono">
                    {{ formatNumber(producto[1].TotalReal) }}
                    {{ producto[1].Pco.M }}
                  </td>
                </tr>
              </template>
              <tr class="rv-totals-row">
                <td class="font-weight-bold">Totales</td>
                <td></td>
                <td></td>
                <td class="text-right font-weight-bold rv-cell-mono">
                  {{ $pgsHelper.formatNumber(selectedReserva.sumatoriaTotal) }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <!-- ── Tabla de Pagos ── -->
        <div class="rv-section mb-6">
          <div class="rv-section-header">

            <span class="rv-section-title">Pagos</span>
          </div>
          <v-divider class="mb-0"></v-divider>
          <v-simple-table class="rv-table">
            <thead>
              <tr class="rv-table-header">
                <th>Método de Pago</th>
                <th class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(pago, index) in selectedReserva.ListPagos
                ? selectedReserva.ListPagos
                : []">
                <tr :key="index" class="rv-table-row">
                  <td data-label="Pago">
                    <div class="d-flex align-center">
                      <v-icon small color="grey" class="mr-2">mdi-wallet-outline</v-icon>
                      {{ pago[1].TipoPago }}
                    </div>
                  </td>
                  <td data-label="Precio" class="text-right rv-cell-mono">
                    {{ formatNumber(pago[1].Cantidad) }} {{ pago[1].Moneda }}
                  </td>
                </tr>
              </template>
              <template v-for="(prop, key) in selectedReserva.Props
                ? selectedReserva.Props
                : []">
                <tr :key="key + 2000" class="rv-table-row rv-propina-row">
                  <td data-label="Pago">
                    <div class="d-flex align-center">
                      <v-icon small color="#f9a825" class="mr-2">mdi-hand-heart-outline</v-icon>
                      <span class="font-italic">Propina {{ getPayMethods[key].Nombre }}</span>
                    </div>
                  </td>
                  <td data-label="Precio" class="text-right rv-cell-mono">
                    {{ formatNumber(prop.Cantidad) }}
                  </td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </div>

        <!-- ── Tarjeta Resumen Financiero: Total + Cambio ── -->
        <v-card class="rv-financial-card elevation-3" rounded="lg">
          <div class="rv-financial-body">
            <v-row align="center" no-gutters>
              <v-col cols="12" sm="7" class="d-flex align-center">
                <v-avatar color="primary" size="48" class="mr-4">
                  <v-icon color="white" large>mdi-currency-usd</v-icon>
                </v-avatar>
                <div>
                  <div class="rv-financial-label">TOTAL DE VENTA</div>
                  <div v-if="!v2" class="rv-financial-amount">
                    {{ selectedReserva.Total ? formatNumber(selectedReserva.Total) : '0' }}
                    <span class="rv-financial-currency">MXN</span>
                  </div>
                  <div v-if="v2" class="rv-financial-amount">
                    {{ selectedReserva.Total ? formatNumber(selectedReserva.Total.C) : '0' }}
                    <span class="rv-financial-currency">MXN</span>
                  </div>
                </div>
              </v-col>
              <v-col v-if="selectedReserva.Cambio" cols="12" sm="5">
                <div class="rv-cambio-section">
                  <v-icon color="rgba(255,255,255,0.7)" small class="mr-1">mdi-cash-refund</v-icon>
                  <span class="rv-cambio-label">Cambio:</span>
                  <span class="rv-cambio-value">{{ $pgsHelper.formatNumber(selectedReserva.Cambio.MXN) }}</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>

      </v-tab-item>

      <!-- ==================== TAB 2: CUENTAS ASOCIADAS ==================== -->
      <v-tab-item v-if="accountData">
        <v-card>
          <v-card-text>
            <v-list-subheader>Información de la cuenta</v-list-subheader>
            <div class="mt-5">
              <v-chip class="mr-1">
                <span class="font-weight-medium mr-1">Cuenta:</span>
                {{ accountData.id }}
              </v-chip>
              <v-chip>
                <span class="font-weight-medium mr-1">Mesa:</span>
                {{ accountData.Contenedor.Nombre }}
              </v-chip>
              <v-chip class="mx-1">
                <span class="font-weight-medium mr-1">Mesero:</span>
                {{ accountData.Mesero.Nombre }}
              </v-chip>
              <v-chip>
                <span class="font-weight-medium mr-1">CD:</span>
                {{ accountData.CD }}
              </v-chip>
            </div>
          </v-card-text>
          <v-subheader>Registro de acciones</v-subheader>
          <v-card-text class="pa-4">
            <v-row v-if="loadingLog" align="center" justify="center" class="py-6">
              <v-col cols="12">
                <div class="subtitle-1 grey--text text-center">Cargando datos...</div>
              </v-col>
            </v-row>
            <div v-else>
              <v-alert v-if="filteredMergedLogs.length === 0" type="info" text dense class="mt-4">
                No se encontraron registros que coincidan con la búsqueda.
              </v-alert>

              <v-card v-for="(log, index) in filteredMergedLogs" :key="index" class="mb-4 elevation-1 rounded-lg">
                <v-sheet :color="log.accion ? 'blue-grey lighten-5' : 'blue lighten-5'" class="px-4 py-2 border-bottom">
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2">
                      {{ log.accion ? 'mdi-alert-circle-outline' : 'mdi-cart-arrow-right' }}
                    </v-icon>
                    <span class="text-overline font-weight-bold grey--text text--darken-3">
                      {{ log.accion ? 'Movimiento a la cuenta' : 'Actividad de Productos' }}
                    </span>
                    <v-spacer></v-spacer>
                  </div>
                </v-sheet>

                <v-card-text class="pt-3">
                  <v-row dense align="center">
                    <v-col cols="12" sm="7">
                      <div class="d-flex align-center mb-1">
                        <v-avatar color="primary" size="24" class="mr-2">
                          <v-icon x-small dark>mdi-account</v-icon>
                        </v-avatar>
                        <div>
                          <span class="text-body-2 font-weight-bold d-block">{{ log.u.n }}</span>
                          <span class="text-caption grey--text">{{ log.u.i }}</span><br />
                          <span class="text-caption grey--text">{{ log.u.t }}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" class="text-sm-right border-left-sm">
                      <div class="d-flex align-center justify-sm-end">
                        <v-icon small color="grey lighten-1" class="mr-1">mdi-calendar-clock</v-icon>
                        <span class="text-caption grey--text text--darken-2 font-weight-medium">{{ formatDate(log.t)
                          }}</span>
                      </div>
                    </v-col>
                  </v-row>


                  <div v-if="log.m && log.m.length > 0">
                    <v-divider class="my-3"></v-divider>
                    <div v-for="(mov, indexMov) in log.m" :key="indexMov" class="mb-2 pa-2 rounded grey lighten-5">
                      <div class="d-flex align-start">
                        <v-icon small class="mr-2 mt-1" :color="mov._PC > 0 ? 'success' : 'error'">
                          {{ mov._PC > 0 ? 'mdi-plus-circle' : 'mdi-minus-circle' }}
                        </v-icon>
                        <div style="width: 100%">
                          <div class="d-flex justify-space-between align-center">
                            <span class="text-body-2">
                              <b :class="mov._PC > 0 ? 'success--text' : 'error--text'">
                                {{ mov._PC > 0 ? 'Agregó' : 'Eliminó' }}
                              </b>
                              <b> ({{ Math.abs(mov._PC) }})</b> {{ mov.Nombre }}
                            </span>
                          </div>

                          <!-- List of modifiers if any -->
                          <div v-if="mov.modificadoresList && mov.modificadoresList.length > 0"
                            class="mt-1 d-flex flex-wrap">
                            <v-chip v-for="(modi, indexModi) in mov.modificadoresList" :key="indexModi" x-small outlined
                              class="mr-1 mb-1" color="grey lighten-1">
                              <span class="grey--text text--darken-2">En cada item: {{ modi.Cnt / mov._PC }} x {{
                                modi.nam
                                }} || Total: {{ modi.Cnt }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2 pa-2 rounded grey lighten-5">
                    <div class="d-flex align-start">
                      <div v-if="log.accion" class="d-flex justify-space-between align-center">
                        <span class="text-body-2">
                          <b>
                            {{ log.accion }}
                          </b>

                        </span>
                      </div>
                    </div>
                  </div>

                </v-card-text>
              </v-card>
            </div>

          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- ==================== TAB 3: DATA ==================== -->
      <v-tab-item>
        <v-card outlined class="mt-2" rounded="lg">
          <v-card-text>
            <v-treeview :items="combinedData" item-text="attribute" item-children="children" open-on-click>
              <template v-slot:prepend="{ item }">
                <span>
                  <b>{{ item.attribute }}:</b>
                </span>
              </template>
              <template v-slot:label="{ item }">
                <span v-if="!item.children">{{ item.value }}</span>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- ==================== TAB 4: RAW ==================== -->
      <v-tab-item>
        <v-card outlined class="mt-2 pa-4" rounded="lg">
          <pre class="rv-raw-pre">{{ selectedReserva }}</pre>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import "../../assets/css/sideBar.css";
import Cliente from "../../clases/Cliente.js";
import Modificadores from "../../clases/Modificadores.js";
import moment from "moment";

export default {
  name: "ReporteVentas",
  components: {},
  props: ["hideMenu", "selectedRes", "v2"],
  data() {
    return {
      activeTab: 0,
      aperturas: [],

      input_orden: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      //selectedRes: "",
      data_clientes: [],
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      data_cajas: [],
      reservations: [],
      cashiers: [],
      selectDep: "",

      accountData: null,
      accountActionsLog: [],
      loadingLog: false,
      searchLog: "",
    };
  },
  computed: {
    combinedData() {
      const formatAttributes = (obj, prefix = "") => {
        return Object.entries(obj).map(([key, value]) => {
          const nombreAtributo = prefix ? `${prefix}.${key}` : key;

          if (typeof value === "object" && value !== null) {
            // Si el valor es un objeto, formatea recursivamente sus hijos
            return {
              attribute: nombreAtributo,
              children: formatAttributes(value), // Crea una sublista para objetos anidados
            };
          } else {
            // Si es un valor primitivo, añádelo como un elemento simple
            return { attribute: nombreAtributo, value: value };
          }
        });
      };

      return formatAttributes(this.selectedReserva);
    },

    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },

    selectedReserva() {
      let selected = this.$pgsHelper.cloneObj(this.selectedRes);
      let totales = 0;
      for (const property in selected.Catalogo) {
        let totalProd = 0;
        if (selected.Catalogo[property].Modificadores) {
          selected.Catalogo[property].ModificadoresList =
            Modificadores.parseToListOption(
              selected.Catalogo[property].Modificadores
            );
          let totalModi = 0;
          selected.Catalogo[property].ModificadoresList.forEach((modi) => {
            totalModi += modi.pco.C;
          });
          selected.Catalogo[property].totalModi = totalModi;
        }
        if (selected.Catalogo[property].Pagos) {
          Object.entries(selected.Catalogo[property].Pagos).forEach((pago) => {
            totales += pago[1].def.C;
            totalProd += pago[1].def.C;
          });
        }
        selected.Catalogo[property].TotalReal = Number(totalProd);
      }

      selected.sumatoriaTotal = totales;

      return selected;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total = total + parseInt(venta.Total);
      });
      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        clientes.push({ value: cli.Id, text: cli.getNombreCompleto() });
      });
      return clientes;
    },
    mergedLogs() {
      const logsFromRes = ((this.accountData && this.accountData._l) || []).map(
        (log) => ({
          ...log,
          timestamp: log.t ? new Date(log.t).getTime() : 0,
        })
      );

      const logsFromActions = (this.accountActionsLog || []).map((log) => ({
        u: {
          n: log.empleado?.nm || "Desconocido",
          t: log.empleado?.tp || "N/A",
          i: log.empleado?.id || "",
        },
        t: log.fecha,
        m: [],
        accion: log.accion,
        timestamp: log.fecha ? new Date(log.fecha).getTime() : 0,
      }));

      return [...logsFromRes, ...logsFromActions].sort(
        (a, b) => a.timestamp - b.timestamp,
      );
    },
    filteredMergedLogs() {
      if (!this.searchLog) return this.mergedLogs;
      const search = this.searchLog.toLowerCase();
      return this.mergedLogs.filter((log) => {
        const userName = log.u?.n?.toLowerCase() || "";
        const userType = log.u?.t?.toLowerCase() || "";
        const action = log.accion?.toLowerCase() || "";
        const date = log.t ? this.formatDate(log.t).toLowerCase() : "";

        let movementMatches = false;
        if (log.m) {
          movementMatches = log.m.some(
            (mov) =>
              mov.Nombre?.toLowerCase().includes(search) ||
              (mov._PC > 0 ? "agrego" : "elimino").includes(search),
          );
        }

        return (
          userName.includes(search) ||
          userType.includes(search) ||
          action.includes(search) ||
          date.includes(search) ||
          movementMatches
        );
      });
    }
  },
  methods: {
    async getAccountLogs(id) {
      if (!id) {
        this.accountActionsLog = [];
        return [];
      }

      this.loadingLog = true;
      try {
        const result = await this.$store.getters.getFirebaseApp.fba.call(
          "AYB-Cuentas-getHistorial",
          { cuentaId: id, tenant: this.$store.getters.tenant },
        );

        if (result.data.ok) {
          this.accountActionsLog = result.data.data || [];
          return this.accountActionsLog;
        }

        this.accountActionsLog = [];
        return [];
      } finally {
        this.loadingLog = false;
      }
    },
    cleanFilter() {
      (this.input_date = moment()),
        (this.input_date_final = moment()),
        (this.input_folio = "");
      this.selectClient = "";
      this.input_orden = "";
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      if (num) {
        if (num != undefined) {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
      }
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    async getCashiers() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cashiers = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cashiers.push(toAdd);
          }
        });
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("FechaVenta", ">=", startDate),
        firestore.where("FechaVenta", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(firestore.where("Departamento", "==", this.selectDep));
      }

      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      if (this.input_orden != "") {
        filter.push(firestore.where("Orden", "==", this.input_orden));
      }

      if (this.selectClient != "") {
        filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);

      this.data_ventas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      this.data_ventas.forEach((item) => {
        item.fecha = new moment(item.FechaCreacion).format("YYYY-MM-DD HH:mm");
      });
      this.data_ventas = this.$_.orderBy(this.data_ventas, "fecha", "desc");
      this.showEstad = true;
      this.loadingData = false;
    },
    async getAccounts() {
      this.accountData = null;
      this.accountActionsLog = [];

      const cuentasAsociadas = new Set();
      Object.values(this.selectedReserva.Catalogo || {}).forEach((producto) => {
        if (producto.ExtraParams?.AYB?.Cnta) {
          cuentasAsociadas.add(producto.ExtraParams.AYB.Cnta);
        }
      });
      if (cuentasAsociadas.size > 1) {
        // console.log("cuentasvarias", cuentasAsociadas);
        return null;
      }
      const id = cuentasAsociadas.values().next().value;
      if (id == undefined) {
        return null;
      }
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("AYB_Cuentas", id);
      const data = await firestore.getDoc(doc);
      if (!data || !data.exists) {
        return null;
      }
      let dataReserva = { id: data.ref.id, ...data.data() };
      // console.log("dataReserva - ", dataReserva.CD, " - ", dataReserva.Mesero.Nombre, " - ", dataReserva.Contenedor.Nombre, " - ", dataReserva);
      this.accountData = dataReserva;
      return dataReserva.id;
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      return new moment(d).format("YYYY-MM-DD HH:mm");
    },
    /* async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Tipo", "==", "Apertura"),
      ];

      if (this.selectDep !== "ALL" && this.selectDep !== "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }

      if (this.selectCaja !== "ALL" && this.selectCaja !== "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }

      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);

      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja =
          this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja) || {};
        let cajeroData =
          this.$pgsHelper.getById(this.cajeros, "Id", apt.Cajero) || {};

        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb || "Desconocido";
        apt.Desc = `Turno Fecha ${fecha.format(
          "DD-MM-YYYY"
        )} Hora: ${fecha.format("HH:mm")} || ${caja.Nomb ||
          "Sin caja"} || ${cajeroData.Nomb || "Sin cajero"} || Turno: ${
          apt.Turno
        }`;
      });
      console.log(aperturas, "aperturas");
      this.aperturas = aperturas;
    }, */
  },
  beforeCreate: function () { },
  beforeMount: async function () {
    await Promise.all([this.getCajas(), this.getCashiers()]);
    const id = await this.getAccounts();
    if (id) {
      await this.getAccountLogs(id);
    }
    // this.getAperturas();
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
/* ─── Container ─── */
.rv-container {
  font-family: "Poppins", sans-serif;
}

/* ─── Tabs ─── */
.rv-tabs {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.rv-tab {
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
}

.rv-tab-content {
  background: #f8fafb;
}

/* ─── Info Card (Folio Header) ─── */
.rv-info-card {
  overflow: hidden;
  border: none !important;
}

.rv-info-header {

  padding: 20px 24px;
  color: #000;
}

.rv-folio-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  opacity: 0.7;
  text-transform: uppercase;
}

.rv-folio-value {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.rv-turno-chip {
  font-size: 12px !important;
  font-weight: 500 !important;
  backdrop-filter: blur(4px);
}

/* ─── Metadata Grid ─── */
.rv-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0;
}

.rv-meta-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.rv-meta-item:hover {
  background-color: #fafbfc;
}

.rv-meta-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.rv-meta-label {
  font-size: 11px;
  font-weight: 500;
  color: #90a4ae;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  line-height: 1;
  margin-bottom: 3px;
}

.rv-meta-value {
  font-size: 14px;
  font-weight: 600;
  color: #37474f;
  line-height: 1.3;
}

/* ─── Section Headers ─── */
.rv-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.rv-section-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #eef1f3;
}

.rv-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #37474f;
  letter-spacing: 0.2px;
}

.rv-count-chip {
  font-size: 11px !important;
  font-weight: 500 !important;
}

/* ─── Tables ─── */
.rv-table {
  border-radius: 0 !important;
}

.rv-table-header th {
  background: #e8f0f7 !important;
  color: #37474f !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.6px !important;
  padding: 10px 16px !important;
  border-bottom: 2px solid #cfe0ec !important;
}

.rv-table-row {
  transition: background-color 0.15s ease;
}

.rv-table-row:hover {
  background-color: #f5f9fc !important;
}

.rv-table-row td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #f0f3f5 !important;
  font-size: 13px !important;
  color: #455a64 !important;
}

.rv-cell-mono {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.rv-totals-row {
  background: #e8f5e9 !important;
}

.rv-totals-row td {
  padding: 14px 16px !important;
  border-bottom: none !important;
  font-size: 14px !important;
  color: #1b5e20 !important;
}

.rv-product-name {
  font-weight: 500;
  color: #263238;
}

.rv-product-date {
  font-size: 12px;
  color: #78909c;
  margin-left: 6px;
}

.rv-sub-items {
  display: flex;
  flex-wrap: wrap;
}

/* ─── Propina Row ─── */
.rv-propina-row {
  background: #fffde7 !important;
}

.rv-propina-row:hover {
  background: #fff9c4 !important;
}

/* ─── Financial Summary Card ─── */
.rv-financial-card {
  overflow: hidden;
  border: none !important;
}

.rv-financial-body {

  padding: 24px 28px;
  color: #000;
}

.rv-financial-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  opacity: 0.75;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.rv-financial-amount {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.5px;
  line-height: 1.1;
}

.rv-financial-currency {
  font-size: 16px;
  font-weight: 500;
  opacity: 0.7;
  margin-left: 4px;
}

.rv-cambio-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 12px 16px;
}

.rv-cambio-label {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.8;
  margin-right: 8px;
}

.rv-cambio-value {
  font-size: 20px;
  font-weight: 700;
}

/* ─── Raw Tab ─── */
.rv-raw-pre {
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  color: #455a64;
  max-height: 500px;
  overflow-y: auto;
  background: #fafafa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
}

/* ─── Responsive ─── */
@media (max-width: 600px) {
  .rv-meta-grid {
    grid-template-columns: 1fr;
  }

  .rv-info-header {
    padding: 16px;
  }

  .rv-folio-value {
    font-size: 18px;
  }

  .rv-financial-amount {
    font-size: 24px;
  }

  .rv-financial-body {
    padding: 18px 20px;
  }

  .rv-cambio-section {
    justify-content: flex-start;
    margin-top: 12px;
  }
}
</style>
